export function captureEvent(event, properties = {}) {
  if (typeof window === "undefined" || typeof window.posthog?.capture !== "function") {
    return;
  }

  window.posthog.capture(event, properties);
}
